/* import React from 'react'; */

import Card from "./Card";

import "./styles/style.scss";

export default Card;

export { default as CardHeader } from "./CardHeader";
export { default as CardContent } from "./CardContent";
export { default as CardFooter } from "./CardFooter";
